@if (currentIdentity(); as identity) {
  <div class="flex flex-col justify-between">
    @if (showMode() === 'all' || showMode() === 'names') {
      <div class="flex flex-col gap-1 py-2">
        <div class="text-xl leading-none font-semibold tracking-tight">Nom officiel</div>
        <div class="text-gray-11 flex items-center gap-1.5">
          {{ identity.firstName }} {{ identity.lastName }}
          <aura-identity-status [status]="identity.verificationStatus" />
        </div>
      </div>
    }
    @if (showMode() === 'all' || showMode() === 'demographics') {
      <div class="flex flex-col gap-1 py-2">
        <div class="text-xl leading-none font-semibold tracking-tight">Sexe</div>
        <div class="text-gray-11">{{ identity.gender | genderDisplay | titlecase }}</div>
      </div>
      <div class="flex flex-col gap-1 py-2">
        <div class="text-xl leading-none font-semibold tracking-tight">Date de naissance</div>
        <div class="text-gray-11">{{ identity.birthDate | luxonDate: 'dd LLL yyyy' }}</div>
      </div>
    }
  </div>
}
